import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toggle , Select, SelectOption} from '@kaleyra/emmy';

import Styles from './CallbackRequiredProfile.module.scss';
import { useToggle } from '../hooks/use-toggle';

interface FormDataProfileProps {
	requiredFormDataProfileData: string;
	setFormDataProfileData: (value: string) => void;
	statusFormDataProfileData: boolean;
	setStatusFormDataProfileData: (value: boolean) => void;
}

const FormDataProfile: React.FC<FormDataProfileProps> = ({
	requiredFormDataProfileData,
	setFormDataProfileData,
	statusFormDataProfileData,
	setStatusFormDataProfileData
}) => {
	const { t } = useTranslation();

	const handleToogle = (
		value: boolean,
	) => {
		setStatusFormDataProfileData(value);
		setFormDataProfileData('');
	}

	return (
		<div>
			<div className={Styles.containerCallbackRequiredText}>
				<div className={Styles.compHeader}>
					{t('enableFormData')}
				</div>
				<div>
					<Toggle onClick={handleToogle} checked={statusFormDataProfileData} />
				</div>
			</div>
			{statusFormDataProfileData && (
				<EnabledFormDataContent
                requiredFormDataProfileData={requiredFormDataProfileData}
                setFormDataProfileData={setFormDataProfileData}
				statusFormDataProfileData={statusFormDataProfileData}
				setStatusFormDataProfileData={setStatusFormDataProfileData}
				/>
			)}
		</div>
	);
};

const EnabledFormDataContent: React.FC<FormDataProfileProps> = ({
	requiredFormDataProfileData,
	setFormDataProfileData,
	statusFormDataProfileData,
	setStatusFormDataProfileData
}) => {
	const { t } = useTranslation();


	// Generic handle change function which takes as input the key that needs to be
	// changed and return a function which change the state of the parent with a callback
	const handleChange = (
		value: string,
	) => {
		setFormDataProfileData(value);
	}

	return (
        <Select
						value={requiredFormDataProfileData ?? ''}
						placeholder={t('selectFormDataOrUrlEncoded')}
						label={t('selectFormDataOrUrlEncoded')}
						onChange={(val) => handleChange(val as string)}
						defaultValue={'Test'}
						disabled={requiredFormDataProfileData === undefined}
						showBottomLabelSpace={false}
					>
							<SelectOption key={'formData'} value={'formData'}>
								{'Form Data'}
							</SelectOption>
                            <SelectOption key={'urlEncoded'} value={'urlEncoded'}>
								{'URL Encoded'}
							</SelectOption>
					</Select>
	);
};

export default FormDataProfile;

